var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeskWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6333 8.72266H2.21236L2 9.12806V11.8501H4.72201V21.3289H5.49422V17.2748H28.3514V21.3289H29.1236V11.8501H31.8456V9.12806L31.6333 8.72266Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6319 8.72202H2.21094L6.07195 1H27.7708L31.6319 8.72202Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17188 11.8301H31.9982",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskWhite);
export default __webpack_public_path__ + "static/media/desk_white.58c4a47e8bb987e93d10fc28bd9de613.svg";
export { ForwardRef as ReactComponent };